import { Col, Form, Row } from 'antd';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { ReactComponent as ListIcon } from '../../../../../assets/icons/check-list.svg';
import { ReactComponent as FinanceIcon } from '../../../../../assets/icons/docs-currency.svg';
import { ReactComponent as NoteIcon } from '../../../../../assets/icons/docs-list.svg';
import { ReactComponent as DocumentIcon } from '../../../../../assets/icons/file-fold.svg';
import { ReactComponent as DetailsIcon } from '../../../../../assets/icons/save-2.svg';
import { ReactComponent as TruckIcon } from '../../../../../assets/icons/truck.svg';
import { setPageBlocker } from '../../../../../redux/common/CommonActions';
import { selectIsPageBlockerActive } from '../../../../../redux/common/CommonReducer';
import SvgConverter from '../../../../components/Common/SvgConverter';
import CollapsiblePanel from '../../../../components/Tabs/CollapsiblePanel';
import LADClaimDetailsForm from '../Edit/Details/LADClaimDetailsForm';
import CreateLADFiles from './Tabs/CreateLADFiles';
import CreateLADFinancials from './Tabs/CreateLADFinancials';
import CreateLADItems from './Tabs/CreateLADItems';
import CreateLADNotes from './Tabs/CreateLADNotes';
import CreateLADSettlements from './Tabs/CreateLADSettlements';

const CreateLDClaimTabs = ({
  activeKeys,
  setActiveKeys,
  claimsDetailsForm,
  items,
  setItems,
  notes,
  setNotes,
  settlements,
  setSettlements,
  files,
  setFiles,
  claimsFinancialsForm,
  checkInstantClaimsDuplicate,
  initValues,
}) => {
  const dispatch = useDispatch();
  const isPageBlockerActive = useSelector(selectIsPageBlockerActive);
  const userData = useSelector((state) => state.auth.user?.data);

  return (
    <CollapsiblePanel
      forceRender
      handleTabClick={(keys) => setActiveKeys(keys)}
      activeKey={activeKeys}
      tabs={[
        {
          tabKey: '1',
          content: (
            <Form
              initialValues={{
                status: 'New',
                dateFiled: moment(new Date()),
                ...(initValues || {}),
              }}
              form={claimsDetailsForm}
              name="claimsDetailsForm"
              onFieldsChange={() => {
                if (!isPageBlockerActive) {
                  dispatch(setPageBlocker(true));
                }
              }}
            >
              <LADClaimDetailsForm
                form={claimsDetailsForm}
                editMode
                preparedBy={`${userData?.firstName} ${userData?.lastName}`}
                checkInstantClaimsDuplicate={checkInstantClaimsDuplicate}
              />
            </Form>
          ),
          header: <GenerateTitle title="Details" Icon={DetailsIcon} size={25} />,
        },
        {
          tabKey: '2',
          content: <CreateLADItems items={items} setItems={setItems} />,
          header: <GenerateTitle title="Claim Items" Icon={TruckIcon} size={25} />,
        },
        {
          tabKey: '3',
          content: (
            <CreateLADFinancials
              claimsFinancialsForm={claimsFinancialsForm}
              claimsDetailsForm={claimsDetailsForm}
              items={items}
            />
          ),
          header: <GenerateTitle title="Claim Financials" Icon={FinanceIcon} size={25} />,
        },
        {
          tabKey: '4',
          content: <CreateLADNotes notes={notes} setNotes={setNotes} />,
          header: <GenerateTitle title="Claim Notes" Icon={NoteIcon} size={25} />,
        },
        {
          tabKey: '5',
          content: <CreateLADFiles files={files} setFiles={setFiles} />,
          header: <GenerateTitle title="Upload/View Files" Icon={DocumentIcon} size={25} />,
        },
        {
          tabKey: '6',
          content: <CreateLADSettlements settlements={settlements} setSettlements={setSettlements} />,
          header: <GenerateTitle title="Claim Settlements" Icon={ListIcon} size={25} />,
        },
      ]}
    />
  );
};

export default CreateLDClaimTabs;

const GenerateTitle = ({ title, Icon, size = 25 }) => {
  return (
    <Row gutter={10} align="middle">
      <Col className="lh-0">
        <SvgConverter width={size} height={size} Icon={Icon} />
      </Col>
      <Col className="lh-0">
        {/* biome-ignore lint/a11y/noLabelWithoutControl: <explanation> */}
        <label className="lh-0 text-dark cursor-pointer">{title}</label>
      </Col>
    </Row>
  );
};
